// API Configuration - Reads from environment variables
const config = {
  // API endpoints
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost/enquiry-form/backend/api',
  uploadBaseUrl: process.env.REACT_APP_UPLOAD_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost/enquiry-form/backend/api',
  apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  
  // Authentication
  tokenKey: process.env.REACT_APP_TOKEN_KEY || 'auth_token',
  
  // Application
  appName: process.env.REACT_APP_NAME || 'Enquiry Dashboard',
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  
  // File Upload
  maxFileSize: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '10485760', 10), // 10MB
  allowedFileTypes: process.env.REACT_APP_ALLOWED_FILE_TYPES || '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.txt,.zip',
  
  // Pagination
  defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '20', 10),
  
  // Environment
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',
};

// Validate required config
if (!config.apiBaseUrl) {
  console.error('REACT_APP_API_BASE_URL is not configured!');
}

export default config;

